// extracted by mini-css-extract-plugin
export default {"container":"style_container__UhvID","header":"style_header__vXjkG","searchWrapper":"style_searchWrapper__rygoW","content":"style_content__n5zLk","footer":"style_footer__ohhXh"};